export default "__VITE_ASSET__vEK9Sy87__"